export const TICKET_STATUS = {
  new: { label: "New", cls: "bg-blue-500/15 text-blue-600" },
  open: { label: "Open", cls: "bg-primary/15 text-primary" },
  in_progress: { label: "In Progress", cls: "bg-amber-500/15 text-amber-600" },
  waiting: { label: "Waiting", cls: "bg-purple-500/15 text-purple-600" },
  resolved: { label: "Resolved", cls: "bg-emerald-500/15 text-emerald-600" },
  closed: { label: "Closed", cls: "bg-muted text-muted-foreground" },
};
export const TICKET_STATUS_ORDER = ["new", "open", "in_progress", "waiting", "resolved", "closed"];
export const TICKET_PRIORITY = {
  low: { label: "Low", dot: "bg-muted-foreground", cls: "bg-muted text-muted-foreground" },
  medium: { label: "Medium", dot: "bg-blue-500", cls: "bg-blue-500/15 text-blue-600" },
  high: { label: "High", dot: "bg-amber-500", cls: "bg-amber-500/15 text-amber-600" },
  urgent: { label: "Urgent", dot: "bg-red-600", cls: "bg-red-600/15 text-red-600" },
};
export const SLA_BADGE = {
  breached: { label: "SLA breached", cls: "bg-red-600/15 text-red-600" },
  at_risk: { label: "At risk", cls: "bg-amber-500/15 text-amber-600" },
  late: { label: "SLA missed", cls: "bg-red-600/10 text-red-600" },
  met: { label: "SLA met", cls: "bg-emerald-500/15 text-emerald-600" },
  ok: { label: "On track", cls: "bg-emerald-500/10 text-emerald-600" },
};
